// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Tools extends APIResource {
    /**
     * Get a specific MCP tool by its ID
     */
    retrieve(toolID, params, options) {
        const { mcp_server_id } = params;
        return this._client.get(path `/v1/mcp-servers/${mcp_server_id}/tools/${toolID}`, options);
    }
    /**
     * Get a list of all tools for a specific MCP server
     */
    list(mcpServerID, options) {
        return this._client.get(path `/v1/mcp-servers/${mcpServerID}/tools`, options);
    }
    /**
     * Execute a specific MCP tool
     *
     * The request body should contain the tool arguments in the ToolExecuteRequest
     * format.
     */
    run(toolID, params, options) {
        const { mcp_server_id, ...body } = params;
        return this._client.post(path `/v1/mcp-servers/${mcp_server_id}/tools/${toolID}/run`, {
            body,
            ...options,
        });
    }
}
//# sourceMappingURL=tools.mjs.map